module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.descriptionToShow)
    }
  }), _vm._v(" "), (_vm.descriptionHasRest) ? [(_vm.collapsed) ? _c('div', {
    staticClass: "text-right text-read-more-less"
  }, [_c('a', {
    staticClass: "text-muted font-weight-normal",
    domProps: {
      "innerHTML": _vm._s(_vm.readMore)
    },
    on: {
      "click": _vm.toggleCollapse
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.collapsed) ? _c('div', {
    staticClass: "text-right text-read-more-less"
  }, [_c('a', {
    staticClass: "text-muted font-weight-normal",
    domProps: {
      "innerHTML": _vm._s(_vm.readLess)
    },
    on: {
      "click": _vm.toggleCollapse
    }
  })]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dda4be0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/multiple/components/variables/choice-description.vue
// module id = 1074
// module chunks = 0